import {
  delegationPersonName,
  type DelegationStatus,
  type SentDelegation,
} from '@littlebird/sdk';

export type DelegatedTo = {
  readonly name: string;
  readonly status: DelegationStatus;
  readonly note: string | null;
  readonly updatedAt: string;
};

const STATUS_LABELS: Record<DelegationStatus, string> = {
  pending: 'Pending',
  done: 'Done',
  dismissed: 'Dismissed',
};

export const toDelegatedTo = (delegation: SentDelegation): DelegatedTo => ({
  name: delegationPersonName(delegation.delegatedTo),
  status: delegation.status,
  note: delegation.note,
  updatedAt: delegation.updatedAt,
});

export const delegatedToLabel = ({ name, status }: DelegatedTo) =>
  `Assigned to ${name} · ${STATUS_LABELS[status]}`;
